<template>
  <div class="deliverable-type-title">
    <span class="field-label">TYPE: </span>
    <span class="title">{{ deliverableTypeTitle(deliverable.deliverable_template_id) }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["deliverable"],
  computed: {
    ...mapGetters([
      'deliverableTypes'
    ])
  },
  methods: {
    deliverableTypeTitle(deliverableTypeId) {
			if(this.deliverableTypes) {
				let typeData = _.filter(this.deliverableTypes, {typeId: deliverableTypeId});
				if(typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},
  },
};
</script>

<style>
</style>